import React from "react";
import styled from "styled-components";

const VARIATIONS = {
  PRIMARY: "primary",
  OUTLINED: "outlined",
  COMPACT: "compact",
  UNSELECTED: "unselected",
};

const getVariationStyle = (theme, variation = VARIATIONS.PRIMARY) => {
  switch (variation) {
    case VARIATIONS.OUTLINED:
      return `
        background-color: ${theme.color.background.light};
        color: ${theme.color.primary.text};
        border: 2px solid ${theme.color.primary.main};
        &:hover{
          background-color: ${theme.color.primary.main};
          color: ${theme.color.text.light};
        }
    `;

    case VARIATIONS.COMPACT:
      return `
        background-color: ${theme.color.primary.main};
        color: ${theme.color.text.light};
        height: 48px;
    `;

    case VARIATIONS.UNSELECTED:
      return `
        background-color: transparent;
        color: ${theme.color.text.secondary};
    `;

    default:
      return `
        background-color: ${theme.color.primary.main};
        color: ${theme.color.text.light};
        border: 2px solid ${theme.color.primary.main};
    `;
  }
};

const StyledButton = styled.button`
  display: -webkit-inline-box;
  display: inline-flex;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  white-space: nowrap;
  line-height: 1;
  font-weight: bold;
  font-size: 16px;
  padding: 14px 15px;
  border-radius: 32px;
  border-style: none;
  height: 54px;
  transition: all 0.25s;
  &:focus,
  :active {
    outline: 0;
    border: 2px solid
      ${({ theme }) => {
        return theme.color.primary.highlight;
      }};
  }
  ${(props) => getVariationStyle(props.theme, props.variation)}
`;

const Button = (props) => {
  return <StyledButton {...props} />;
};

export default Button;
